import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { readJSONOrText } from '../utils';

var parseResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, params) {
    var result, deserializer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return readJSONOrText(response);

          case 2:
            result = _context.sent;

            if (!(typeof result === 'string')) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", result);

          case 5:
            deserializer = params.deserializer;

            if (typeof deserializer === 'function' && result != null && result.data != null) {
              result.data = deserializer(result.data);
            }

            params.end({
              result: result,
              headers: response.headers
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function parseResponse(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export var createParseResponseMiddleware = function createParseResponseMiddleware() {
  return parseResponse.bind(null);
};
//# sourceMappingURL=parse-response.js.map